{
    "websiteName": "click.ro",
    "websitePushID": "web.click-ro.adh.reperio.news",
    "allowedDomains": [
        "https://click.ro",
        "https://www.click.ro"
    ],
    "urlFormatString": "https://click.ro/%@",
    "authenticationToken": "19f8d7a6e9fb8a7f6d9330dabe",
    "webServiceURL": "https://click.ro/apple_webpush"
}
